---
fr:
  navigation:
    error:
      no_company_selected: Aucune entreprise sélectionnée
      too_many_power_plants_selected: Trop de centrales sélectionnées
    language:
      de: Allemand
      en: Anglais
      fr: Français
      nb: Norvégien
      select: Sélectionnez la langue
    main_menu:
      admin_market_prices: Prix du marché
      admin_volumes: Volumes
      admin_weather: Prévisions météorologiques
      api_access: Accès API
      api_docs: Documentation API
      availability: Analyse de disponibilité
      availability_analysis: Analyse de disponibilité
      benchmarking: Benchmarking
      budget_forecasts: Prévisions budgétaires
      commercial_scada: Commercial SCADA
      community_access: Accès à la communauté
      companies: Entreprises
      components: Composants
      contracts: Contracts
      data_export: Exportation de données
      elcert_and_goos: Elcert et GoOs
      elhub: Elhub
      fall_lease: Concession
      feature_requests: Demandes de fonctionnalités
      follow_up: Revue de la performance
      full_map: Carte complète
      home: Accueil
      liquidity_planning: Planification de la liquidité
      log_out: Déconnexion
      map: Carte
      market_data: Données des prix
      market_outlook: Prix du marché à terme
      market_prices: Prix historiques
      marketplace: Place de marché
      more_information: Plus d'informations
      nest: Nest
      news_items: Articles
      nve_plants: Plantes NVE
      o_and_m_dashboard_v1: Tableau de bord O&M v1
      om_dashboard: Tableau de bord
      operations: Exploitation
      portfolio: Portefeuille
      portfolio_stats: Statistiques portefeuille
      power_plants: Centrale
      pp_info: Information sur la centrale électrique
      ppa_pricing: Tarification PPA
      production_scheduling: Planification de prod.
      production_simulation_plan: Plan de simulation de production
      profile: Profil
      public_kiosk_mode: Mode kiosque public
      responsibles: Responsables
      root: Racine
      subsidiaries: Filiales
      suppliers: Fournisseurs
      task_management: Gestion des tâches
      users: Utilisateurs
      white_labeling: Personnalisation de marque blanche
    production_simulation_plan_query: Exécuter la requête de simulation de production
